// NOTE: This file is just temporary all models should be moved to interfaces lib

export enum ProductLine {
    ATELLICA_LOW_VOLUME = 'ATELLICA_LOW_VOLUME',
    ATELLICA_MID_VOLUME = 'ATELLICA_MID_VOLUME',
    ATELLICA_HIGH_VOLUME = 'ATELLICA_HIGH_VOLUME',
    DIMENSION = 'DIMENSION',
    CENTAURO = 'CENTAURO',
    HEMOSTASIS_CS_SERIES = 'HEMOSTASIS_CS_SERIES',
    HEMOSTASIS_CA_SERIES = 'HEMOSTASIS_CA_SERIES',
    HEMOSTASIS_CN = 'HEMOSTASIS_CN'
}
